<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="65%" @close="handleClose"
      append-to-body>
      <el-container class="container" direction="vertical">
        <!-- 患者基本信息 -->
        <el-descriptions :column="4" border style="margin-bottom: 16px;">
          <el-descriptions-item label="患者姓名" span="2">{{ formData.patientName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="登记号" span="2">{{ formData.recordNo || '-' }}</el-descriptions-item>
          <el-descriptions-item label="性别" span="1">{{ formData.gender || '-' }}</el-descriptions-item>
          <el-descriptions-item label="年龄" span="1">{{ formData.age || '-' }}</el-descriptions-item>
          <el-descriptions-item label="联系方式" span="2">{{ formData.phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="身份证号" span="2">{{ formData.idcard || '-' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 管理方案信息 -->
        <el-descriptions :column="4" border style="margin-bottom: 16px;">
          <template slot="title">
            <strong>管理方案信息</strong>
          </template>
          <el-descriptions-item label="管理标签" span="2">
            <el-select v-model="form.managementTag" placeholder="请选择管理标签" style="width:100%">
              <el-option v-for="tag in manageTagsList" :key="tag" :label="tag" :value="tag" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="手术情况" span="2">
            <el-select v-model="form.surgeryStatus" placeholder="请选择" style="width:100%">
              <el-option v-for="(x, index) in surgicalSituationList" :key="index" :label="x.label" :value="x.value" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="病理类型" span="2">
            <el-select v-model="form.pathologicalType" placeholder="请选择" style="width:100%">
              <el-option v-for="(x, index) in pathologicalTypeList" :key="index" :label="x.label" :value="x.value" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="复查到期时间" span="2">
            <el-checkbox v-model="form.noReview" style="margin-right: 8px;">不复查</el-checkbox>
            <el-date-picker v-model="form.reviewDueDate" type="date" placeholder="选择复查到期时间" style="width:100%"
              value-format="yyyy-MM-dd" :disabled="form.noReview"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="随诊建议" span="4">
            <el-input type="textarea" v-model="form.followUpSuggestion" :rows="2" placeholder="请输入随诊建议"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="备注" span="4">
            <el-input type="textarea" v-model="form.remarks" :rows="2" placeholder="请输入备注"></el-input>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 随访信息 -->
        <el-descriptions :column="4" border style="margin-bottom: 16px;">
          <template slot="title">
            <strong>随访信息</strong>
          </template>
          <el-descriptions-item label="随访备注" span="4">
            <el-input type="textarea" v-model="form.annotation" :rows="2" placeholder="请输入随访备注"></el-input>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 随访人信息（自动填充） -->
        <el-descriptions :column="4" border>
          <template slot="title">
            <strong>随访人信息</strong>
          </template>
          <el-descriptions-item label="随访人" span="2">{{ userInfos.name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="随访机构" span="2">{{ userInfos.hospitalName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="随访科室" span="2">{{ userInfos.deptName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="随访机构电话" span="2">{{ userInfos.hospitalPhone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="随访时间" span="2">{{ userInfos.codiagTime || '-' }}</el-descriptions-item>
        </el-descriptions>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-popconfirm title="是否确认提交？" @confirm="handleSubmit">
          <el-button slot="reference" type="primary">提交随访单</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfos } from "@/api/health/Patients";
import { postListLungDetail, submitLungcancerFollowup, postPatientFollowupGroupsByGroupName, getCancerManagePlanByIdcard } from "@/api/health/Lung";
import moment from "moment";

export default {
  data() {
    return {
      showDialog: false,
      title: "肺结节随访单",
      form: {
        managementTag: null,
        surgeryStatus: null,
        pathologicalType: null,
        followUpSuggestion: null,
        reviewDueDate: null,
        noReview: false,
        remarks: null,
        annotation: null,
      },
      resetForm: {
        managementTag: null,
        surgeryStatus: null,
        pathologicalType: null,
        followUpSuggestion: null,
        reviewDueDate: null,
        noReview: false,
        remarks: null,
        annotation: null,
      },
      formData: {},
      userInfos: {},
      manageTagsList: [],
      surgicalSituationList: [
        { label: "未手术", value: "未手术" },
        { label: "已手术", value: "已手术" }
      ],
      pathologicalTypeList: [
        { label: "腺癌", value: "腺癌" },
        { label: "鳞癌", value: "鳞癌" },
        { label: "小细胞肺癌", value: "小细胞肺癌" },
        { label: "大细胞肺癌", value: "大细胞肺癌" },
        { label: "其他", value: "其他" }
      ],
    }
  },
  watch: {
    'form.noReview'(val) {
      if (val) {
        this.form.reviewDueDate = null;
      }
    }
  },
  methods: {
    async init(value) {
      this.formData = { ...value };

      // 获取管理标签
      this.getManageTags();
      // 获取病理和手术信息
      this.loadListLungDetail({ idcard: value?.idcard });
      // 默认代入当前管理方案
      if (value?.idcard) {
        getCancerManagePlanByIdcard({ idcard: value.idcard }).then(res => {
          if (res.msg === 'success' && res.data) {
            const plan = res.data;
            this.form.managementTag = plan.managementTag || null;
            this.form.surgeryStatus = plan.surgeryStatus || null;
            this.form.pathologicalType = plan.pathologicalType || null;
            this.form.followUpSuggestion = plan.followUpSuggestion || null;
            this.form.reviewDueDate = plan.reviewDueDate || null;
            this.form.noReview = plan.reviewFlag === 0;
            this.form.remarks = plan.remarks || null;
          }
        }).catch(err => console.log(err));
      }
      // 获取用户信息
      getUserInfos({}).then((res) => {
        if (res.msg == "success") {
          this.userInfos.name = res.data.name || '';
          this.userInfos.hospitalPhone = res.data.hospitalPhone || '';
          this.userInfos.hospitalName = res.data.hospitalName || '';
          this.userInfos.deptName = res.data.deptName || '';
          this.getSystemTime();
          this.showDialog = true;
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    getManageTags() {
      postPatientFollowupGroupsByGroupName({}).then(res => {
        if (res.msg === 'success') {
          this.manageTagsList = res.data?.records?.map(x => x.groupName) || [];
        }
      }).catch(err => console.log(err));
    },
    loadListLungDetail(props) {
      const { idcard } = props;
      if (!idcard) return;
      postListLungDetail({ ...props }).then(res => {
        this.surgicalSituationList = [{ label: "未手术", value: "未手术" }, { label: "已手术", value: "已手术" }];
        this.pathologicalTypeList = [{ label: "腺癌", value: "腺癌" }, { label: "鳞癌", value: "鳞癌" }, { label: "小细胞肺癌", value: "小细胞肺癌" }, { label: "大细胞肺癌", value: "大细胞肺癌" }, { label: "其他", value: "其他" }];
        if (res.data && res.data.length > 0) {
          const surgeryOptions = res.data.map(x => ({
            label: x.surgery_name_main,
            value: x.surgery_name_main
          })).filter(x => x.label);
          if (surgeryOptions.length > 0) {
            this.surgicalSituationList = [{ label: "未手术", value: "未手术" }, ...surgeryOptions];
          }
          const pathologyOptions = res.data.map(x => ({
            label: x.diag_name_pathology,
            value: x.diag_name_pathology
          })).filter(x => x.label);
          if (pathologyOptions.length > 0) {
            this.pathologicalTypeList = [{ label: "无", value: "无" }, ...pathologyOptions];
          }
        }
      }).catch(err => console.log(err));
    },
    getSystemTime() {
      const time = new Date();
      const year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      const hour = time.getHours().toString().padStart(2, '0');
      const minute = time.getMinutes().toString().padStart(2, '0');
      const second = time.getSeconds().toString().padStart(2, '0');
      this.userInfos.codiagTime = `${year}-${month}-${date} ${hour}:${minute}:${second}`;
    },
    async handleSubmit() {
      const submitData = {
        idcard: this.formData.idcard,
        managementTag: this.form.managementTag,
        surgeryStatus: this.form.surgeryStatus,
        pathologicalType: this.form.pathologicalType,
        followUpSuggestion: this.form.followUpSuggestion,
        reviewDueDate: this.form.reviewDueDate,
        reviewFlag: this.form.noReview ? 0 : 1,
        remarks: this.form.remarks,
        annotation: this.form.annotation,
        followupDoctor: this.userInfos.name,
        followupDept: this.userInfos.deptName,
        followupHospital: this.userInfos.hospitalName,
        followupPhone: this.userInfos.hospitalPhone,
        followupTime: this.userInfos.codiagTime,
      };

      submitLungcancerFollowup(submitData).then(res => {
        if (res.msg === 'success') {
          this.$message({ message: "肺结节随访单提交成功！", type: "success" });
          this.$emit("upDataList");
          this.handleClose();
        } else {
          this.$message({ message: res.msg || "提交失败！", type: "error" });
        }
      }).catch(err => {
        console.log(err);
        this.$message({ message: "提交失败！", type: "error" });
      });
    },
    handleClose() {
      this.form = { ...this.resetForm };
      this.showDialog = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-height: 600px;
  overflow-y: auto;
}
</style>
